import { render, staticRenderFns } from "./CreateParcel.vue?vue&type=template&id=fc92c72a&scoped=true&"
import script from "./CreateParcel.vue?vue&type=script&lang=ts&"
export * from "./CreateParcel.vue?vue&type=script&lang=ts&"
import style0 from "./CreateParcel.vue?vue&type=style&index=0&id=fc92c72a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc92c72a",
  null
  
)

/* custom blocks */
import block0 from "./CreateParcel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports